<template>
  <div class="footer text-center">
    <hr>
    <span class="text-footer"> © 2019 Produits du Vallon Sàrl</span>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
.footer{margin-top:3rem; font-size: 0.7rem}
hr{margin-bottom: 3rem; max-width: 20rem}
</style>
